import { render, staticRenderFns } from "./BillingData.vue?vue&type=template&id=11b60afa&scoped=true"
import script from "./BillingData.vue?vue&type=script&lang=js"
export * from "./BillingData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b60afa",
  null
  
)

export default component.exports